import { createFileRoute } from '@tanstack/react-router';

import { preloadProgressData } from 'hooks/useQuery/useQueryProgressData';
import { preloadSourceApps } from 'hooks/useQuery/useQuerySourceApps';

import { HomeView } from 'views/HomeView/HomeView';

export const Route = createFileRoute('/_auth/home')({
  component: HomeView,
  beforeLoad: () => {
    return {
      backTarget: null,
    };
  },

  loader: async ({ context: { queryClient } }) => {
    await Promise.all([preloadSourceApps(queryClient), preloadProgressData(queryClient)]);
  },
});
